import React from 'react';

import { IProductTemplateAttribute, Validation } from 'components/dashboard/product-template-table/utils/interfaces';
import { Chips, ChipsChangeParams } from 'primereact/chips';
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { CellType } from 'utils/enums';
import ValidationOptions from './components/ValidationOptions';

type StringTypeProps = {
	attribute: IProductTemplateAttribute;
	onAttrChangeInString: React.Dispatch<
		React.SetStateAction<IProductTemplateAttribute>
	>;
};

const StringType: React.FC<StringTypeProps> = ({
	attribute,
	onAttrChangeInString,
}) => {
	const onFieldChange = (e: ChipsChangeParams | DropdownChangeParams) =>
		onAttrChangeInString(prev => ({
			...prev,
			[e.target.name]: e.target.value,
		}));

  const handleValidationChange = (validators: Validation[]) => {
    onAttrChangeInString(prev => ({
      ...prev,
      validationOptions: {
        ...prev.validationOptions,
        validators
      }
    }))
  }

	return (
    <>
      <div className="p-field p-col-12">
        <label>Selection values</label>
        <Chips
          value={attribute.selectionValues ?? []}
          onChange={onFieldChange}
          name="selectionValues"
          separator=","
        />
      </div>
      <div className="p-field p-col-6">
        <label>Default value</label>
        <Dropdown
          value={attribute.defaultValue}
          options={attribute.selectionValues ?? []}
          onChange={onFieldChange}
          name="defaultValue"
          className="p-inputtext-sm"
          editable
        />
      </div>
      <div className="flex-1 flex w-full align-self-center justify-content-center gap-3">
        <label htmlFor="shortenText">Shorten text</label>
        <InputSwitch
          id="shortenText"
          checked={attribute.shortenText ?? false}
          onChange={onFieldChange}
          name="shortenText"
          className="p-inputtext-sm"
        />
      </div>
      <ValidationOptions
        cellType={CellType.STRING}
        validators={attribute.validationOptions?.validators ?? []}
        onValidationChange={handleValidationChange}
      />
    </>
  );
};

export default StringType;
